/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A VDK Web utility library. (@accedo/vdkweb-utils) 5.0.4
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineMediaType = exports.MediaType = void 0;
var _MediaTypeFormatMap;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MediaType = {
  MP4: 'MP4',
  MPEGDASH: 'MPEG-DASH',
  HLS: 'HLS'
};
exports.MediaType = MediaType;
var MediaTypeFormatMap = (_MediaTypeFormatMap = {}, _defineProperty(_MediaTypeFormatMap, MediaType.MP4, 'mp4'), _defineProperty(_MediaTypeFormatMap, MediaType.MPEGDASH, 'mpd'), _defineProperty(_MediaTypeFormatMap, MediaType.HLS, 'm3u8'), _MediaTypeFormatMap);
var determineMediaType = function determineMediaType(mediaUrl) {
  var url = new URL(mediaUrl);
  var type = null;
  Object.keys(MediaTypeFormatMap).forEach(function (t) {
    if (url.pathname.endsWith(MediaTypeFormatMap[t])) {
      type = t;
    }
  });
  return type;
};
exports.determineMediaType = determineMediaType;